module.exports = __webpack_public_path__ + "static/media/patients-activated.a89aa9ac.svg";